import { identifyUser } from '@iwLogger/IwDataDogLogger';
import { fork, put, takeLatest, select } from 'redux-saga/effects';

import {
    REDIRECTING_TO_SIGNUP,
    RETRIEVE_SITE_CONTEXT,
    SET_IMPERSONATING_STATE_KEY,
    SET_SITE_CONTEXT_ERROR_DATA,
    SET_SITE_CONTEXT_READY_DATA,
    SKIP_SITE_CONTEXT_API
} from './IwSiteContext.actions';
import { putAndWaitAPI } from '../api/API.sagas';
import {
    API_GET_SITE_CONTEXT,
    API_GET_SITE_CONTEXT_FAIL,
    API_GET_SITE_CONTEXT_SUCCESS
} from '../api/lendingAPI/LendingAPI.actions';
import { deserialiseSiteContext } from '../api/lendingAPI/SiteContextAPIHelper';
import {
    BOOTSTRAP_INTERCOM,
    SETUP_INTERCOM
} from '../iwIntercom/IwIntercom.actions';
import { getCountry, setCountry } from '../iwIntlProvider/CountryProvider';
import { SET_LOCALE } from '../iwIntlProvider/IwIntlProvider.actions';
import {
    isLinkingOpenBankingOnly,
    redirectToLogin
} from '../iwRouter/LocationHelper';
import { SETUP_THREATMETRIX } from '../iwThreatmetrix/iwThreatmetrix.actions';
import * as tracking from '../tracking/tracking';

export const siteContextSagaWorkers = [
    fork(retrieveSiteContextWorker),
    fork(skipSiteContextWorker)
];

function* skipSiteContextWorker() {
    yield takeLatest(SKIP_SITE_CONTEXT_API, function* (action) {
        const siteContext = deserialiseSiteContext(action.site_context);
        yield redirectOnUncompleteSignup(siteContext);
        yield put({
            type: API_GET_SITE_CONTEXT_SUCCESS,
            response: {
                pending: false,
                data: action.site_context.data
            }
        });
        yield setupSiteContext(siteContext);
    });
}

function* retrieveSiteContextWorker() {
    yield takeLatest(RETRIEVE_SITE_CONTEXT, function* (action) {
        const nextAction = yield putAndWaitAPI({
            type: API_GET_SITE_CONTEXT,
            contextStateKey: action.impersonatingStateKey
        });

        yield put({
            type: SET_IMPERSONATING_STATE_KEY,
            impersonatingStateKey: action.impersonatingStateKey,
            loggedInUserType: nextAction.response.data.logged_in_user_type
        });

        switch (nextAction.type) {
            case API_GET_SITE_CONTEXT_SUCCESS:
                const siteContext = deserialiseSiteContext(nextAction.response);
                yield redirectOnUncompleteSignup(siteContext);
                yield setupSiteContext(siteContext);

                break;
            case API_GET_SITE_CONTEXT_FAIL:
                yield put({
                    type: SET_SITE_CONTEXT_ERROR_DATA,
                    data: nextAction.response.data
                });

                redirectToLogin();
                break;
        }
    });
}

function* redirectOnUncompleteSignup(siteContext) {
    if (isLinkingOpenBankingOnly()) return;
    if (siteContext.user_signup_finished) return;
    if (siteContext.is_iwocapay_seller) return;
    let targetLocation = '/my_account/';

    yield put({ type: REDIRECTING_TO_SIGNUP });
    window.location.href = targetLocation;
}

function* setupSiteContext(siteContext) {
    const isImpersonating = yield select(
        ({ siteContext }) => siteContext.impersonating
    );
    setCountry(siteContext.country_code);
    yield put({
        type: SET_SITE_CONTEXT_READY_DATA,
        data: siteContext
    });
    yield put({ type: SET_LOCALE, data: siteContext });

    identifyUser({
        state_key: siteContext.state_key,
        impersonating: isImpersonating
    });

    tracking.initialise();
    tracking.identify({
        stateKey: siteContext.state_key,
        country: getCountry(),
        isImpersonating
    });

    if (siteContext.loggedInUserType === 'customer' && !isImpersonating) {
        yield put({ type: SETUP_THREATMETRIX });
    }

    yield put({ type: SETUP_INTERCOM, siteContext });
    yield put({ type: BOOTSTRAP_INTERCOM, siteContext });
}
